import { Box } from '@mui/material';

import RegularChart from '@/components/Chart/RegularChart';
import type {
  ChartType,
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/components/Chart/types/highcharts';
import { CHART_HEIGHT } from '@/features/DataHub/constants/charts';

const PreviewChartLayout = ({
  chartSeries,
  chartType,
  error,
  loading,
  options
}: {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
  chartType: ChartType;
  error: boolean;
  loading: boolean;
  options: ExtendedOptions | undefined;
}) => (
  <Box sx={{ minHeight: CHART_HEIGHT, position: 'relative' }}>
    <RegularChart
      chartSeries={chartSeries}
      chartType={chartType}
      error={error}
      loading={loading}
      options={options}
      showLegend={false}
    />
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1
      }}
    />
  </Box>
);

export default PreviewChartLayout;
